module.exports = __webpack_public_path__ + "img/2.5559d6c7.jpeg";